import clsx from 'clsx';
import type { SelectHTMLAttributes } from 'react';

import { Icon } from './Icon';
import styles from './Select.module.css';

export interface SelectOption<T extends string> {
  value: T;
  label: string;
}

export interface SelectProps<T extends string>
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'> {
  value: T;
  options: readonly SelectOption<T>[];
  onValueChange: (value: T) => void;
  label: string;
}

export function Select<T extends string>({
  value,
  options,
  onValueChange,
  label,
  className,
  ...rest
}: SelectProps<T>) {
  return (
    <span className={styles.wrapper}>
      <select
        aria-label={label}
        className={clsx(styles.select, className)}
        value={value}
        onChange={(event) => onValueChange(event.target.value as T)}
        {...rest}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className={styles.chevron}>
        <Icon name="chevron-down" size={14} />
      </span>
    </span>
  );
}
